import { module as Module } from 'modujs';
import { loadImage } from '../utils/image';
import gsap from 'gsap';

export default class ColorsViewers extends Module {
    static GAP_SELECTOR_BUTTONS = 4; //px
    static FADE_TRANSITION = 0.4; //secs

    constructor(m) {
        super(m);

        this.$root = this.el;
        this.$selectors = this.$('selector');
        this.$selectorBg = this.$('selector-bg')[0];

        this.$exterior = this.$('exterior')[0];
        this.$interior = this.$('interior')[0];
        this.$exteriorThumbnail = this.$('exterior-thumbnail')[0];
        this.$interiorThumbnail = this.$('interior-thumbnail')[0];

        this.currentSet = this.getData('current-set');
        this.imagesSet = JSON.parse(this.getData('image-set'));

        this.events = {
            click: {
                switch: 'onSwitchClick',
                selector: 'onSelectorClick'
            },
            mouseenter: {
                selector: 'onSelectorMouseEnter'
            },
            mouseleave: {
                selector: 'onSelectorMouseLeave'
            }
        };
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();

        this.$selectors[0].classList.add('-is-selected');
        this.$selectorBg.style.transform = `translate3d(${
            this.$selectors[0].offsetLeft - ColorsViewers.GAP_SELECTOR_BUTTONS
        }px, 0, 0)`;
        this.$selectorBg.style.width = `${this.$selectors[0].offsetWidth}px`;
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener('resize', this.onResize);
    }

    unbindEvents() {
        window.removeEventListener('resize', this.onResize);
    }

    ///////////////
    // Methods
    ///////////////
    onResize = () => {
        const $selected = this.$('selector.-is-selected')[0];
        this.$selectorBg.style.transform = `translate3d(${
            $selected.offsetLeft - this.GAP_SELECTOR_BUTTONS
        }px, 0, 0)`;
        this.$selectorBg.style.width = `${$selected.offsetWidth}px`;
    };

    onSwitchClick(e) {
        this.el.classList.toggle('-is-even-active');
    }

    onSelectorClick(e) {
        const $target = e.target;
        const index = Array.from(this.$selectors).indexOf($target);

        this.currentSet = $target.getAttribute('data-color');

        this.$selectors.forEach(($selector) => $selector.classList.remove('-is-selected'));
        $target.classList.add('-is-selected');

        this.$selectorBg.style.transform = `translate3d(${
            $target.offsetLeft - ColorsViewers.GAP_SELECTOR_BUTTONS - index * 2
        }px, 0, 0)`;
        this.$selectorBg.style.width = `${$target.offsetWidth}px`;

        this.updateImages();
    }

    onSelectorMouseEnter(e) {
        const $target = e.target;
        const index = Array.from(this.$selectors).indexOf($target);

        $target.classList.add('-is-hover');

        this.$selectorBg.style.transform = `translate3d(${
            $target.offsetLeft - ColorsViewers.GAP_SELECTOR_BUTTONS - index * 2
        }px, 0, 0)`;
        this.$selectorBg.style.width = `${$target.offsetWidth}px`;
    }

    onSelectorMouseLeave(e) {
        const $target = e.target;

        $target.classList.remove('-is-hover');

        if (!$target.classList.contains('-is-selected')) {
            const $selected = this.$('selector.-is-selected')[0];

            this.$selectorBg.style.transform = `translate3d(${
                $selected.offsetLeft - ColorsViewers.GAP_SELECTOR_BUTTONS
            }px, 0, 0)`;
            this.$selectorBg.style.width = `${$selected.offsetWidth}px`;
        } else {
            this.$selectorBg.style.transform = `translate3d(${
                $target.offsetLeft - ColorsViewers.GAP_SELECTOR_BUTTONS
            }px, 0, 0)`;
            this.$selectorBg.style.width = `${$target.offsetWidth}px`;
        }
    }

    async updateImages() {
        this.el.classList.add('is-loading');

        const {
            exterior: eImage,
            interior: iImage,
            exteriorSmall: eThumbImage,
            interiorSmall: iThumbImage
        } = this.imagesSet.find((image) => image.id === this.currentSet);

        try {
            const [eImg, iImg, eThumbImg, iThumbImg] = await Promise.all([
                loadImage(eImage),
                loadImage(iImage),
                loadImage(eThumbImage),
                loadImage(iThumbImage)
            ]);

            gsap.delayedCall(0.3, () => {
                this.el.classList.remove('is-loading');

                //requestAnimationFrame(() => {
                this.setImage(this.$exterior, eImg.url);
                this.setImage(this.$interior, iImg.url);
                this.setImage(this.$exteriorThumbnail, eThumbImg.url);
                this.setImage(this.$interiorThumbnail, iThumbImg.url);
                //});
            });
        } catch (error) {
            console.error('Error loading images:', error);
            this.el.classList.remove('is-loading');
        }
    }

    setImage(container, src) {
        const imageContainerParallax = container.querySelector('.c-image_parallax');
        const imageContainerSmall = container.querySelector('.c-image_inner');
        const imageContainer = imageContainerParallax || imageContainerSmall;

        const oldImg = container.querySelector('img');

        const newImg = oldImg.cloneNode();
        newImg.src = src;
        newImg.style.position = 'absolute';
        newImg.style.top = '0px';
        newImg.style.left = '0px';
        newImg.style.width = '100%';
        newImg.style.height = '100%';
        newImg.style.opacity = 0;
        newImg.style.transition = 'none';
        imageContainer.appendChild(newImg);

        gsap.to(newImg, {
            opacity: 1,
            duration: ColorsViewers.FADE_TRANSITION,
            onComplete: () => {
                oldImg.remove();
            }
        });
    }
}
